import { createRouter, createWebHistory } from "vue-router";
// import Dashboard from "../views/Dashboard.vue";
import Card from "@/views/Card.vue";
import User from "@/views/User.vue";
// import Job from "../views/Job.vue" ;
// import Apply from "../views/Apply.vue" ;
// import Contact from "../views/Contact.vue" ;
import RTL from "@/views/Rtl.vue";
import Signup from "@/views/Signup.vue";
import Signin from "@/views/Signin.vue";
import SmartCard from "@/views/smartCardComponent/SmartCard.vue"
import SmartCardServices from "@/views/smartCardComponent/Services.vue"
import SmartCardProducts from "@/views/smartCardComponent/Products.vue"
import SmartCardCatalogues from "@/views/smartCardComponent/Catalogues.vue"

import axios from "axios";
import APIs from "../../config";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/cards",
  },
  {
    path: "/dashboard-default",
    name: "card",
    component: Card,
  },
  {
    path: "/cards",
    name: "card",
    component: Card,
  },
  {
    path: "/users",
    name: "user",
    component: User,
  },
  {
    path: "/rtl-page",
    name: "RTL",
    component: RTL,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/S/:smartCardID",
    name: "smartCard",
    component: SmartCard,
  },
  {
    path: "/S/services/:smartCardID",
    name: "smartCardServices",
    component: SmartCardServices,
  },
  {
    path: "/S/products/:smartCardID",
    name: "smartCardProducts",
    component: SmartCardProducts,
  },
  {
    path: "/S/catalogues/:smartCardID",
    name: "SmartCardCatalogues",
    component: SmartCardCatalogues,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  var get_token = localStorage.getItem('admin_token')
  if ((to.name === 'card' || to.name === 'user') && get_token) {
      var get_user_id = localStorage.getItem('admin_id')
      axios
      .get(`${APIs.API_URL}/admin/${get_user_id}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${get_token}`
        }
      })
      .then(() => {
        return next()
      })
      .catch(err => {
          console.error(err)
          localStorage.removeItem("admin_token")
          location.reload()
          next({ name: 'Signin' })            
      });
  }
  else {
    if (to.name === 'card' || to.name === 'user')
      next({ name: 'Signin' })
  }
  next()
})
export default router;
